import { ApplicationState } from "@redux/reducers";
import { useCallback } from "react";
import { useSelector } from "react-redux";

export const useCaptcha = () => {
    const { captcha_enabled, captcha_keys } = useSelector((state: ApplicationState) => state.appData.settings);
    const getCaptchaData = useCallback(async () => {
        if (captcha_enabled && typeof window !== "undefined" && window.grecaptcha && captcha_keys.length > 0) {
            const token = await window.grecaptcha.execute(captcha_keys[0].key);
            return {
                type: captcha_keys[0].captcha_type,
                token,
            };
        }
        return undefined;
    }, [captcha_keys, captcha_enabled]);

    return { getCaptchaData };
};
